/**
 * Loma Brand Colors
 * These constants provide a central reference for all brand colors used in the application
 */

// Primary brand colors
export const LOMA_GREEN = "#04e393"; // Vibrant mint green from logo
export const LOMA_DARK_TEAL = "#0a3933"; // Dark teal background from logo

// Secondary and accent colors
export const LOMA_GREEN_HOVER = "#03c580"; // Darker version of the primary green for hover states
export const LOMA_LIGHT_TEAL = "#d1dbdb"; // Light teal used in backgrounds
export const LOMA_PALE_GREEN = "#e0f5ee"; // Very light green for subtle accents

// UI state colors
export const LOMA_BLACK = "#000000"; // Black for text and UI elements
export const LOMA_GRAY_HOVER = "#2D3748"; // Gray.700 for hover states
export const LOMA_GRAY_LIGHT = "#4A5568"; // Gray.600 for borders and secondary elements

// Colors from HTML landing page
export const LOMA_LANDING_DARK_TEAL = "#0F4245"; // Dark teal from landing page
export const LOMA_LANDING_BRIGHT_GREEN = "#17E098"; // Bright green from landing page
export const LOMA_LANDING_LIGHT_BG = "#f9fdfb"; // Light background from landing page
export const LOMA_LANDING_TABLE_HEADER = "#d6f2df"; // Table header green
export const LOMA_LANDING_TABLE_ROW = "#f3fdf7"; // Table row green
export const LOMA_LANDING_TABLE_ALT_ROW = "#f8fcf9"; // Table alternate row
export const LOMA_LANDING_SOCIAL_CARD = "#043f41"; // Social card background
export const LOMA_LANDING_GRADIENT_START = "#00e69f"; // Gradient start color
export const LOMA_LANDING_GRADIENT_END = "#00cc8a"; // Gradient end color
export const LOMA_LANDING_INDIGO = "#536DFE"; // Gradient end color

// Export a colors object for easy consumption
export const lomaColors = {
  primary: LOMA_GREEN,
  darkTeal: LOMA_DARK_TEAL,
  primaryHover: LOMA_GREEN_HOVER,
  lightTeal: LOMA_LIGHT_TEAL,
  paleGreen: LOMA_PALE_GREEN,
  black: LOMA_BLACK,
  grayHover: LOMA_GRAY_HOVER,
  grayLight: LOMA_GRAY_LIGHT,
  // Landing page colors
  landingDarkTeal: LOMA_LANDING_DARK_TEAL,
  landingBrightGreen: LOMA_LANDING_BRIGHT_GREEN,
  landingLightBg: LOMA_LANDING_LIGHT_BG,
  landingTableHeader: LOMA_LANDING_TABLE_HEADER,
  landingTableRow: LOMA_LANDING_TABLE_ROW,
  landingTableAltRow: LOMA_LANDING_TABLE_ALT_ROW,
  landingSocialCard: LOMA_LANDING_SOCIAL_CARD,
  landingGradientStart: LOMA_LANDING_GRADIENT_START,
  landingGradientEnd: LOMA_LANDING_GRADIENT_END,
}; 